'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalState$ = exports.getGlobalStateValues = exports.updateGlobalState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rxjs = require('rxjs');

var globalState = new _rxjs.BehaviorSubject({});
var globalState$ = globalState.asObservable();

var globalFXState = new _rxjs.BehaviorSubject({
  hideUIFundTypes: []
});
var globalFXState$ = globalFXState.asObservable();

var modalState = new _rxjs.BehaviorSubject({
  modalConfig: {
    display: 'none',
    modalType: 'loading',
    modalContent: ''
  }
});
var modalState$ = modalState.asObservable();

var StateService = {
  updateGlobalState: function updateGlobalState() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    globalState.next(_extends({}, globalState.getValue(), newState));
  },
  getGlobalStateValues: function getGlobalStateValues() {
    return globalState.getValue();
  },
  getGlobalState$: function getGlobalState$() {
    return globalState$;
  },
  updateFXGlobalState: function updateFXGlobalState() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    globalFXState.next(_extends({}, globalFXState.getValue(), newState));
  },
  getFXGlobalStateValues: function getFXGlobalStateValues() {
    return globalFXState.getValue();
  },
  getFXGlobalState$: function getFXGlobalState$() {
    return globalFXState$;
  },
  updateModalState: function updateModalState() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    modalState.next(_extends({}, modalState.getValue(), newState));
  },
  getModalState$: function getModalState$() {
    return modalState$;
  }
};

exports.default = StateService;
var updateGlobalState = StateService.updateGlobalState,
    getGlobalStateValues = StateService.getGlobalStateValues,
    getGlobalState$ = StateService.getGlobalState$;
exports.updateGlobalState = updateGlobalState;
exports.getGlobalStateValues = getGlobalStateValues;
exports.getGlobalState$ = getGlobalState$;